module.exports = __webpack_public_path__ + "static/customer-d658b04bca9a3270e53d08d34c1dbd59.jpg";